/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobBatchRequest {
    getFixupPrototypeFunction() { return PolicyJobBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobBatchRequest>): PolicyJobBatchRequest {
        let obj = Object.assign(new PolicyJobBatchRequest(), model);
        PolicyJobBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobBatchRequest>): PolicyJobBatchRequest {
        if (!model) return null;
        return PolicyJobBatchRequest.newInstance(<PolicyJobBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobBatchRequest) {
        if (!obj) return;

        models.PolicyJobBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobBatchRequest): boolean {
        Object.setPrototypeOf(obj, PolicyJobBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique IDs of Policy Jobs
     */
    policy_job_ids: Array<string>;

}
